import TabBadges from "@/components/Table/MrtCaseFilters/TabBadges.tsx";
import { Button, ButtonGroup } from "@mui/material";
import CaseTaskBadgeForCaseStatus from "./CaseTaskBadgeForCaseStatus";
import NotificationBadgeForCaseStatus from "./NotificationBadgeForCaseStatus";

type Props = {
    selectedTab: string;
    setSelectedTab: (selectedTab: string) => void;
};

const AttorneyPreLitFilters = ({ selectedTab, setSelectedTab }: Props) => {
    return (
        <ButtonGroup aria-label="Basic button group" fullWidth sx={{ mb: 2 }}>
            <Button
                onClick={() => setSelectedTab("")}
                variant={selectedTab === "" ? "contained" : "outlined"}
            >
                All Cases
                <TabBadges />
            </Button>
            <Button
                onClick={() => setSelectedTab("Denial")}
                variant={selectedTab === "Denial" ? "contained" : "outlined"}
            >
                Denial
                <NotificationBadgeForCaseStatus caseStatus="Denial" />
                <CaseTaskBadgeForCaseStatus caseStatus="Denial" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Negotiation")}
                variant={selectedTab === "Negotiation" ? "contained" : "outlined"}
            >
                Negotiation
                <NotificationBadgeForCaseStatus caseStatus="Negotiation" />
                <CaseTaskBadgeForCaseStatus caseStatus="Negotiation" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Litigation Review")}
                variant={selectedTab === "Litigation Review" ? "contained" : "outlined"}
            >
                Litigation Review
                <NotificationBadgeForCaseStatus caseStatus="Litigation Review" />
                <CaseTaskBadgeForCaseStatus caseStatus="Litigation Review" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Hold Harmless")}
                variant={selectedTab === "Hold Harmless" ? "contained" : "outlined"}
            >
                Hold Harmless
                <NotificationBadgeForCaseStatus caseStatus="Hold Harmless" />
                <CaseTaskBadgeForCaseStatus caseStatus="Hold Harmless" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Checks Printed")}
                variant={selectedTab === "Checks Printed" ? "contained" : "outlined"}
            >
                Checks Printed
                <NotificationBadgeForCaseStatus caseStatus="Checks Printed" />
                <CaseTaskBadgeForCaseStatus caseStatus="Checks Printed" />
            </Button>
            <Button
                onClick={() => setSelectedTab("Disbursed")}
                variant={selectedTab === "Disbursed" ? "contained" : "outlined"}
            >
                Disbursed
                <NotificationBadgeForCaseStatus caseStatus="Disbursed" />
                <CaseTaskBadgeForCaseStatus caseStatus="Disbursed" />
            </Button>
        </ButtonGroup>
    );
};

export default AttorneyPreLitFilters;
